import { DiffBasketUtil } from '@/utils/DiffBasket'

import { computed } from 'vue'

import useContract from '@/hooks/useContract'
import usePerson from '@/hooks/usePerson'

// Hooks
const { contractPersonsWithDetails } = useContract()
const { getSelectedProductsByCategory, personsWithDetails } = usePerson()

const MODE = {
  CHANGED: 'changed',
  EXISTING: 'existing',
}

// Computed
const basketPersons = computed(() => {
  return personsWithDetails.value.filter(p => p.contractModified)
})

const contractPersons = computed(() => {
  return contractPersonsWithDetails.value.filter(p =>
    basketPersons.value.some(bp => bp.contractNumber === p.contractNumber)
  )
})

const diffPersons = computed(() => {
  return getDiffPersons(contractPersons.value, basketPersons.value)
})

// Methods
function fillCategories(currentCategories, person, mode) {
  const contractNumber = person.contractNumber
  getSelectedProductsByCategory(person.selectedProducts).forEach(category => {
    currentCategories = DiffBasketUtil.addCategoryToList(currentCategories, contractNumber, category, mode)
  })
}

function getDiffPersons(oldBasket, newBasket) {
  let personMap = new Map()
  let categories = {}

  newBasket.forEach(p => {
    fillCategories(categories, p, MODE.CHANGED)
    DiffBasketUtil.mapPerson(personMap, p, MODE.CHANGED)
  })

  oldBasket.forEach(p => {
    fillCategories(categories, p, MODE.EXISTING)
    DiffBasketUtil.mapPerson(personMap, p, MODE.EXISTING)
  })

  DiffBasketUtil.addSortedCategoriesToMap(personMap, categories)
  return [...personMap.values()]
}

export default function useDiffBasket() {
  return {
    // Computed
    basketPersons,
    contractPersons,
    diffPersons,
  }
}
